import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Loading, StarRating, EmptyState } from "@/components/shared";
import { Trophy, Flag, TrendingUp } from "lucide-react";

export default function Rankings() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/rankings").then(({ data }) => setData(data)).catch(() => setData({ top_rated: [], most_flagged: [] })); }, []);
  if (!data) return <Loading label="Loading rankings" />;

  return (
    <main className="mx-auto max-w-[1800px] px-6 py-12 sm:px-10 lg:px-16">
      <p className="eyebrow mb-3">Benchmarks</p>
      <h1 className="text-4xl font-bold">iGaming employer rankings</h1>
      <p className="mt-3 max-w-xl text-slate-400">Data-driven leaderboards you won't find on a generic review site, built from verified employee signals.</p>

      <div className="mt-10 grid gap-8 lg:grid-cols-2">
        <section>
          <h2 className="flex items-center gap-2 text-xl font-bold"><Trophy className="h-5 w-5 text-teal-400" /> Top rated</h2>
          {data.top_rated.length === 0 ? <div className="mt-4"><EmptyState icon={TrendingUp} title="Not enough data yet" /></div> : (
            <div className="mt-4 space-y-3">
              {data.top_rated.map((c, i) => (
                <Link key={c.id} to={`/company/${c.id}`} data-testid="rank-top" className="card-surface lift flex items-center gap-4 p-4">
                  <span className={`grid h-9 w-9 place-items-center rounded-full font-heading font-bold ${i < 3 ? "bg-teal-500 text-white" : "bg-black/[0.04] text-slate-400"}`}>{i + 1}</span>
                  <div className="flex-1"><p className="font-semibold">{c.name}</p><p className="text-xs text-slate-500">{c.location} · {c.review_count} reviews</p></div>
                  <div className="flex items-center gap-2"><StarRating value={c.avg_overall} size={14} /><span className="font-heading font-bold text-teal-400">{c.avg_overall}</span></div>
                </Link>
              ))}
            </div>
          )}
        </section>

        <section>
          <h2 className="flex items-center gap-2 text-xl font-bold"><Flag className="h-5 w-5 text-coral-500" /> Most red-flagged</h2>
          {data.most_flagged.length === 0 ? <div className="mt-4"><EmptyState icon={Flag} title="No red flags reported" /></div> : (
            <div className="mt-4 space-y-3">
              {data.most_flagged.map((c) => (
                <Link key={c.id} to={`/company/${c.id}`} data-testid="rank-flagged" className="card-surface lift flex items-center justify-between p-4">
                  <div><p className="font-semibold">{c.name}</p><p className="text-xs text-slate-500">{c.location}</p></div>
                  <span className="flex items-center gap-1.5 rounded-full border border-coral-500/30 bg-coral-500/10 px-3 py-1 text-sm text-coral-500"><Flag className="h-4 w-4" /> {c.red_flag_count}</span>
                </Link>
              ))}
            </div>
          )}
        </section>
      </div>
    </main>
  );
}
